module.exports = __webpack_public_path__ + "img/darktheme.bcd704cf.png";